// extracted by mini-css-extract-plugin
export default {"content":"AuthModal_content__kxVE-","form":"AuthModal_form__LnK7Q","footer":"AuthModal_footer__Gg6HU","input":"AuthModal_input__qdPGI"};